export const validationMap = {
  roles: {
    helperText: 'Field is required',
    isError: (value: string|undefined): boolean => !value && !value?.length,
  },
  username: {
    helperText: 'Field is required',
    isError: (value: string|undefined): boolean => !value?.length,
  },
  password: {
    helperText: 'Field is required',
    isError: (value: string|undefined): boolean => !value?.length,
  },
};
